var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper"},[(_vm.nodes && _vm.nodes.length)?_vm._l((_vm.nodes),function(node,index){return _c(node.tag,{key:index,tag:"component",attrs:{"config":node}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }